import * as angular from "angular";

angular
  .module('bringoz.admin.service-analysis')
  .config(serviceAnalysisConfig);

/* @ngInject */
function serviceAnalysisConfig($stateProvider) {

  $stateProvider
    .state('analysis-logs-planning', {
      parent: 'bringoz.site',
      url: '/planning/analysis-logs',
      template: '<analysis-logs-view></planning-analysis-logs-view>',
      controller: function ($scope, triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Logs"});
        triBreadcrumbsService.addCrumb({name: "Planning"});

      }
    })

}
